import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { finalize, map, share, shareReplay, tap } from 'rxjs/operators';
import { environment } from '../../../environments';
import { PrismHeaders } from '../../enums';
import { Job } from '../../models';
import { JobsResponse } from '../../models/http-response/jobs-response';


@Injectable()
export class JobsService implements OnInit {

	private downloadData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	private selectedJobBS: BehaviorSubject<Job> = new BehaviorSubject<Job>(null);
	private isGetJobsLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
	private isPostJobLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
	private isPutJobLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
	private jobsBSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
	public downloadProgress = {};

	constructor(private http: HttpClient) {
	}

	ngOnInit() {
	}

	get jobs$() {
		return this.jobsBSubject.asObservable();
	}

	get selectedJobCurrent() {
		return this.selectedJobBS.value;
	}

	get selectedJob$() {
		return this.selectedJobBS.asObservable()
      .pipe(
        share()
      );
	}

	setSelectedJob(job: Job) {
		this.selectedJobBS.next(job);
	}

	clearNotification(job: Job, notification: 'newRaws' | 'other') {
    const headers = new HttpHeaders()
      .append(PrismHeaders.QueryData, JSON.stringify({pathToJob: job.pathToProcessorJob, notification}));

	  return this.http.get(`${environment.apiBaseUrl}/ClearJobNotification`, {headers});
  }

	fetchJobsFromDatabase({pageIndex, pageSize}) {
    const headers = new HttpHeaders()
      .append(PrismHeaders.QueryData, JSON.stringify({pageIndex, pageSize}));

    this.switchGetJobsLoaderOn();

		return this.http.get(environment.apiBaseUrl + '/GetJobsProcessor', {headers})
				.pipe(
						tap((jobs: JobsResponse) => {
							this.jobsBSubject.next(jobs.data);
						}),
						shareReplay(1),
						finalize(() => {
							this.switchGetJobsLoaderOff();
						}),
				);
	}

	clearDownloadData() {
		this.downloadData.next(null);
	}

	get isGetJobsLoading$() {
		return this.isGetJobsLoading.asObservable();
	}

	get isPostJobLoading$() {
		return this.isPostJobLoading.asObservable();
	}

	get isPutJobLoading$() {
		return this.isPutJobLoading.asObservable();
	}

	get areJobsLoading$() {
		return combineLatest(this.isGetJobsLoading$, this.isPostJobLoading$, this.isPutJobLoading$)
				.pipe(
						map(x => _.includes(x, true))
				);
	}

	switchGetJobsLoaderOn() {
		this.isGetJobsLoading.next(true);
	}

	switchGetJobsLoaderOff() {
		this.isGetJobsLoading.next(false);
	}

	getSearchedServiceDetails({searchTags}) {
    const headers = new HttpHeaders()
      .append(PrismHeaders.QueryData, JSON.stringify({searchTags}));

    return this.http.get(`${environment.apiBaseUrl}/GetServicesDetails`, {headers});
  }

	getServicesDetails({pageSize, pageIndex}): Observable<any> {
	  const headers = new HttpHeaders()
      .append(PrismHeaders.QueryData, JSON.stringify({pageSize, pageIndex}));

	  return this.http.get(`${environment.apiBaseUrl}/GetServicesDetails`, {headers});
  }

  getServicesFinals({finalDirectories}): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/GetServicesFinals`, {finalDirectories});
  }

}
